<template>
  <cc-container class="invoice">
    <!-- <cc-header-nav title="我的发票" url="/user/index?goback=1"> -->
    <cc-header-nav title="我的发票" url="/#/management">
      <cc-svg-icon @click="showDatePicker" size="20px" slot="right" icon-class="calendar"></cc-svg-icon>
    </cc-header-nav>
    <cc-fade>
      <div style="position:relative;">
        <cc-date-filter  v-show="dateFilterVisible" @search="handleDateFilter" @cancel="emptyData" ref="dateFilter"></cc-date-filter>
      </div>
    </cc-fade>
    <div class="search-box" style="border-bottom:5px solid #eeeeee;">
      <input
        v-model="invoice_code"
        @keyup.13="search"
        class="input-search"
        type="text"
        placeholder="发票号码"
      />
      <cc-svg-icon
        v-if="iconVisible==1"
        size=".16rem"
        @click="invoice_code = ''"
        class-name="cancel-icon"
        icon-class="cancel"
      ></cc-svg-icon>
      <cc-svg-icon
        v-if="iconVisible==0"
        size=".16rem"
        @click="search"
        class-name="search-icon"
        icon-class="search"
      ></cc-svg-icon>
    </div>
    <cc-main>
      <div class="data-top">
        <span>发票号码</span>
        <span>时间</span>
        <span>操作</span>
      </div>
      <van-list
        class="invoice-list"
        v-model="m_loading"
        :finished="m_finished"
        :finished-text="m_finishedText"
        @load="mHandlePullUpLoadMore"
        :immediate-check="m_immediateCheck"
      >
        <cc-not-order v-if="list.length === 0 && m_loading === false" tip="亲，暂无发票信息哦" :show="false"></cc-not-order>
        <cc-animation-list>
          <div class="invoice-item" v-for="(item,index) in list" :key="index">
            <span style=""><span style="margin-left:20px;text-align:left;display:inline-block;width:100%;">{{item.invoice_code}}</span></span>
            <span>{{item.created_time}}</span>
            <span @click="seePdf(item.id,item.file_path)">预览</span>
          </div>
        </cc-animation-list>
      </van-list>
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>
<script>
import Vue from 'vue'
import { Lazyload, List, Tab, Tabs, Dialog } from 'vant'
import ListMixin from '@/mixins/list'
import { ResultCode } from '~const/ResultCode'
import { selfInvoice } from '../../fetch/invoice/index.js'
Vue.use(Lazyload)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(Dialog)
export default {
  mixins: [ListMixin],
  data () {
    return {
      // 搜索清除图标的显示隐藏
      iconVisible: 0,
      // 日期组件的显示隐藏
      dateFilterVisible: false,
      // 发票号码
      invoice_code: '',
      // 发票列表
      list: []
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    invoice_code () {
      if (this.invoice_code.length > 0) {
        this.iconVisible = 1
      } else {
        this.iconVisible = 0
      }
    }
  },
  methods: {
    showDatePicker () {
      this.dateFilterVisible = ~this.dateFilterVisible
    },
    async loadData (reset) {
      if (reset) {
        this.list = []
      }
      this.mRequest()
      var params = {
        page: this.m_page.curr,
        limit: 20,
        invoice_code: this.invoice_code,
        start_time: this.start_time,
        end_time: this.end_time
      }
      let { data, status } = await selfInvoice(params)

      if (status === ResultCode.SUCCESS) {
        if (data.return_data.length === 0) {
          // 全部数据加载完成
          this.m_finishedText = ''
          this.mEnd()
        } else {
          this.list = [...this.list, ...data.return_data]
          if (data.return_data.length < 20) {
            this.m_finishedText = '已全部加载完成'
            this.mEnd()
          }
        }
        this.mSuccess()
      } else {
        this.mEnd()
      }
    },
    /**
     * @description 根据时间搜索
     */
    handleDateFilter ({ startDate, endDate }) {
      this.start_time = startDate
      this.end_time = endDate
      this.search()
      this.dateFilterVisible = false
    },
    emptyData ({ startDate, endDate }) {
      // 父组件改变子组件的值
      this.$refs.dateFilter.startDate = ''
      this.$refs.dateFilter.endDate = ''
    },
    /**
     * @description 根据订单号搜索
     */
    search () {
      this.mReset()
      const reset = true
      this.loadData(reset)
    },
    /**
     * @description 在线预览发票
     */
    seePdf (id, url) {
      this.$router.push({ path: '/invoice/list/detail', query: { id, url } })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/index.scss";
.invoice {
  background: #fff;
  .search-box {
    height: 40px;
    position: relative;
    @include center(column);
    .input-search {
      height: 28px;
      width: 91%;
      border-radius: 2px;
      border: 1px solid $border-color-base;
      padding-left: 10px;
      font-size: 12px;
    }
    .cancel-icon,
    .search-icon {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 20px;
    }
  }
  .data-top,
  .invoice-item {
    height: 40px;
    border-bottom: 1px solid #f7f6f6;
    display: flex;
    align-items: center;
  }
  .data-top > span {
    text-align: center;
    font-size: 14px;
  }
  .invoice-item > span {
    text-align: center;
    font-size: 12px;
  }
  .invoice-item > span:nth-child(1),
  .invoice-item > span:nth-child(3),
  .data-top > span:nth-child(1),
  .data-top > span:nth-child(3) {
    flex: 1;
  }
  .invoice-item > span:nth-child(2),
  .data-top > span:nth-child(2) {
    flex: 2;
  }
  .invoice-item > span:nth-child(3) {
    color: #1bb0d9;
  }
}
</style>
